import e, { forwardRef as m } from "react";
import { Text as c } from "../../../Text/Text.js";
import { cls as n } from "../../../../helpers/cls.js";
const t = m((_ref, i) => {
  let {
    children: a,
    adUrl: l,
    adUrlTarget: r,
    mode: d = "horizontal",
    titleID: o
  } = _ref;
  return e.createElement("a", {
    className: "olx-ad-card__title-link",
    "data-ds-component": "DS-NewAdCard-Link",
    href: l,
    target: r,
    ref: i,
    tabIndex: -1,
    id: o
  }, e.createElement(c.TitleSmall, {
    className: n("olx-ad-card__title", "olx-ad-card__title--".concat(d)),
    tag: "h2"
  }, a));
});
t.displayName = "Title";
export { t as Title };